export default {"src":"/_next/static/media/bag.70f6a318.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};